import React from "react";
import { IntlProvider } from "react-intl";
import "@formatjs/intl-pluralrules/polyfill";
import "@formatjs/intl-pluralrules/locale-data/fr";
import {
  ThemeProvider,
  StyledEngineProvider,
  CssBaseline,
} from "@mui/material";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { SnackbarProvider } from "notistack";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "@syos-music/auth";

import createLapidouTheme, { useThemeMode } from "lib/theme";
import { SyosApolloProvider } from "lib/apollo";
import Layout from "components/common/Layout";

import Router from "./_router";

const intlMessages = {
  ...require("@syos-music/form/lang/fr.json"),
  ...require("@syos-music/instruments/lang/fr.json"),
  ...require("@syos-music/products/lang/fr.json"),
};

export default function App(props) {
  const { Component = Router, pageProps = {} } = props;

  const [themeMode] = useThemeMode();
  const theme = React.useMemo(() => createLapidouTheme(themeMode), [themeMode]);

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <CssBaseline />

        <SnackbarProvider>
          <IntlProvider locale="fr" messages={intlMessages}>
            <DndProvider backend={HTML5Backend}>
              <AuthProvider apiUrl={process.env.REACT_APP_API_BASE_URL}>
                <SyosApolloProvider>
                  <BrowserRouter basename={process.env.PUBLIC_URL}>
                    <Layout>
                      <Component {...pageProps} />
                    </Layout>
                  </BrowserRouter>
                </SyosApolloProvider>
              </AuthProvider>
            </DndProvider>
          </IntlProvider>
        </SnackbarProvider>
      </ThemeProvider>
    </StyledEngineProvider>
  );
}
